// External deps
import { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import PropTypes from 'prop-types';
import { parseISO } from 'date-fns';
import esLocale from 'date-fns/locale/es';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { formatFullDate, formatsEnum } from '../../../utils/formatUtils';

import 'react-datepicker/dist/react-datepicker.css';
import './DateInputCalendar.scss';
import CustomDateInput from './components/CustomDateInput';

registerLocale('es', esLocale);
dayjs.extend(utc);

const DateInputCalendar = ({ minDate, maxDate, selectDay, label, handleChangeDate, arrayDate }) => {
  const initDayFormated =
    selectDay || formatFullDate(new Date(), formatsEnum.FORMAT_DATE_2).concat('T00:00:00');
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const selectedDay = dayjs(initDayFormated).toDate();

  const toggleOpenDatePicker = () => {
    setOpenDatePicker((open) => !open);
  };

  const datePickerValues = (date) => {
    const formattedDate = formatFullDate(new Date(date), formatsEnum.FORMAT_DATE_2).concat(
      'T00:00:00'
    );

    handleChangeDate(formattedDate);
    setOpenDatePicker(false);
  };

  const renderDate = (day, date) => {
    let classDay = '';
    const today = formatFullDate(new Date(), formatsEnum.FORMAT_DATE_1);
    const newDate = formatFullDate(date, formatsEnum.FORMAT_DATE_1);
    const selectDayFormat = formatFullDate(selectedDay, formatsEnum.FORMAT_DATE_1);
    const dateFormat = formatFullDate(date, formatsEnum.FORMAT_DATE_1);

    const isPendient = arrayDate.some(
      (d) => formatFullDate(d, formatsEnum.FORMAT_DATE_1) === newDate
    );

    // Current day (blue border)
    if (dateFormat === today && !isPendient) {
      classDay = 'day-blue-light';
    }
    // Selected day with no pending lines (blue background)
    if (dateFormat === selectDayFormat && !isPendient) {
      classDay = 'day-blue';
    }
    // The date has pending lines (red border)
    if (isPendient) {
      classDay = 'day-red-light';
      // Selected date with pending lines (red background)
      if (newDate === selectDayFormat) {
        classDay = 'day-red';
      }
    }

    return <div className={`date-calendar ${classDay}`}>{day}</div>;
  };

  return (
    <div className="calendar-container">
      <div className="calendar-container-content">
        <DatePicker
          format="DD/MM/YYYY"
          id="date-input-calendar"
          locale="es"
          maxDate={parseISO(maxDate)}
          minDate={parseISO(minDate)}
          onChange={datePickerValues}
          onClickOutside={() => setOpenDatePicker(false)}
          open={openDatePicker}
          openToDate={new Date(formatFullDate(selectedDay, formatsEnum.FORMAT_DATE_3))}
          renderDayContents={renderDate}
          showDisabledMonthNavigation
          size="small"
          todayButton="Hoy"
        />
        <div aria-hidden id="calendar-div">
          <CustomDateInput label={label} onClick={() => toggleOpenDatePicker()} value={selectDay} />
        </div>
      </div>
    </div>
  );
};

DateInputCalendar.propTypes = {
  label: PropTypes.string.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  selectDay: PropTypes.string,
  handleChangeDate: PropTypes.func,
  arrayDate: PropTypes.arrayOf(PropTypes.string)
};

DateInputCalendar.defaultProps = {
  minDate: '',
  maxDate: '',
  selectDay: '',
  handleChangeDate: () => {
    /* empty */
  },
  arrayDate: []
};

export default DateInputCalendar;
